import * as actionTypes from "./../../Constants/locations/locationActionTypes";
import API from "./../../Constants/locations/API";
import * as locationServices from "../../services/locations/index";

export const locations = (locationData) => ({
    type: actionTypes.FETCH_ALL_LOCATIONS,
    payload: { locationData: locationData }
})

export function fetchAllLocations(firmId) {    
    return async dispatch => {
        const request = await locationServices.req.getAllLocations(API.getAllLocations, firmId)
        return dispatch(locations(request))

    };
}

 //CLEAR FILTERS ACTION
export function clearAllFilters(isClearFilters, allLocations) {   
    allLocations = allLocations.map((locations) => {
        locations.selected = false;        
        return locations;
    });

    return dispatch => {
        return dispatch({
            payload: { isClearFilters, allLocations },
            type: actionTypes.CLEAR_ALL_FILTERS
        });
    };
}

// GET VISIBLE ROWS COUNT
export function getRowsCountAfterFilter(rowsCount) {
    return dispatch =>
        dispatch({
            payload: { rowsCount },
            type: actionTypes.ROWS_COUNT_AFTER_FILTER
        });
}

//DELETE SELECTED ROW.
export function deleteLocation(branchId) {
    return async dispatch => {
        const requestDelete = await locationServices.req.deleteLocation(API.deleteLocation, branchId)
        return dispatch({
            type: actionTypes.DELETE_LOCATION,
            payload: { requestDelete }
        });
    };
}

//DISCARD CHANGES YES
export function discardChanges() {
    return dispatch =>
        dispatch({
            type: actionTypes.DISCARD_CHANGES
        });
}

//ADD NEW LOCATION
export function addNewLocation(isAddNewLocation){
    return dispatch =>
        dispatch({
            payload: { isAddNewLocation },
            type: actionTypes.ADD_NEW_LOCATION
        });
}